import React from 'react';

import ForumContribute from '../ForumContribute';
import ForumFilteredThreadsList from '../ForumFilteredThreadsList';
import './style.scss';

const ForumAskKooth = () => {
  return (
    <div className="has-background">
      <ForumContribute askKooth isNarrow hasBackgroundWhite />
      <ForumFilteredThreadsList location={{query: {askKooth: 'true'}}} />
    </div>
  );
};

export default ForumAskKooth;



/** WEBPACK FOOTER **
 ** ./src/members/Main/Forum/ForumAskKooth/index.js
 **/